var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4693 6.69656L13.3255 4.8404C13.7085 4.45707 14.1632 4.15295 14.6638 3.94541C15.1643 3.73787 15.7008 3.63099 16.2427 3.63086C16.7846 3.63073 17.3211 3.73737 17.8218 3.94467C18.3224 4.15198 18.7773 4.45589 19.1605 4.83904C19.5436 5.2222 19.8475 5.67709 20.0548 6.17773C20.2621 6.67838 20.3688 7.21496 20.3687 7.75682C20.3685 8.29868 20.2616 8.83521 20.0541 9.33576C19.8466 9.8363 19.5424 10.2911 19.1591 10.674L16.5075 13.3257C16.1244 13.7087 15.6697 14.0126 15.1692 14.2199C14.6687 14.4272 14.1323 14.5339 13.5906 14.5339C13.0489 14.5339 12.5125 14.4272 12.0121 14.2199C11.5116 14.0126 11.0569 13.7087 10.6738 13.3257",
    stroke: "#272163",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5302 17.3031L10.674 19.1593C10.2911 19.5426 9.8363 19.8467 9.33576 20.0543C8.83521 20.2618 8.29868 20.3687 7.75682 20.3688C7.21496 20.369 6.67838 20.2623 6.17773 20.055C5.67709 19.8477 5.2222 19.5438 4.83904 19.1606C4.45589 18.7775 4.15198 18.3226 3.94467 17.822C3.73737 17.3213 3.63073 16.7847 3.63086 16.2429C3.63099 15.701 3.73787 15.1645 3.94541 14.6639C4.15295 14.1634 4.45707 13.7086 4.8404 13.3257L7.49205 10.674C7.87509 10.291 8.32983 9.98712 8.8303 9.77982C9.33077 9.57252 9.86717 9.46582 10.4089 9.46582C10.9506 9.46582 11.487 9.57252 11.9874 9.77982C12.4879 9.98712 12.9426 10.291 13.3257 10.674",
    stroke: "#272163",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.5cabe5a1.svg";
export { ForwardRef as ReactComponent };